import { useMemo } from 'react';

import type { ExtractedTableJson } from '@frontend/api/src/parts/useGetExtractedTables';

import { getKeyForExtractedTableJson } from 'modules/common/viewer/pdfViewer/annotationCommands/suggestionUtils';
import { useSelectedTable } from 'modules/extractedTables/SelectedTableContext';
import { useAnnotationInteractions } from 'modules/extractedTables/hooks/useAnnotationInteractions';

import type { SuggestionAnnotationRaw } from '../annotationCommands/types';

type UseExtractedTableAnnotationsParams = {
  extractedTables: ExtractedTableJson[] | undefined;
};

export function useExtractedTableAnnotations({
  extractedTables,
}: UseExtractedTableAnnotationsParams): {
  extractedTableAnnotations: SuggestionAnnotationRaw[];
} {
  const { selectedTableUrl, setSelectedTableUrl, rawTableData } =
    useSelectedTable();

  const extractedTableKey = useMemo(
    () =>
      rawTableData ? getKeyForExtractedTableJson(rawTableData) : undefined,
    [rawTableData],
  );

  const { tableAnnotations: extractedTableAnnotations } =
    useAnnotationInteractions({
      extractedTablesData: extractedTables,
      hasSelectedTable: !!selectedTableUrl,
      setSelectedTableUrl,
      extractedTableKey,
    });

  return { extractedTableAnnotations };
}
